// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/weather_actual_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WeatherActualService } from "./weather_actual_service_pb";

/**
 * GetAreaWeatherActual returns the koma-aggregated observation series for
 * the area and target-date range. organization_id is resolved by the BFF
 * handler from eauth.
 *
 * @generated from rpc bffuser.v1.WeatherActualService.GetAreaWeatherActual
 */
export const getAreaWeatherActual = WeatherActualService.method.getAreaWeatherActual;

/**
 * BatchGetAreaWeatherActuals returns one actual per requested area, in request order
 * (area_code identifies each element), for the shared target-date range.
 * organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.WeatherActualService.BatchGetAreaWeatherActuals
 */
export const batchGetAreaWeatherActuals = WeatherActualService.method.batchGetAreaWeatherActuals;
